const ImageConstant = {
	// BlurDataURL:
	//   "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAoAAAAKCAYAAACNMs+9AAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAABSSURBVHgBrZCxCoBADENzItcv6NYP96Z+YLcupbcoCE4OVjFLMjwCSYuIHQUtKOo7OLYBVX0GO3XMnDewVcesV3B3ZObpIgIzAxGBmd81/n/PAXpnHmcTvpaoAAAAAElFTkSuQmCC",

	BlurDataURL: "/assets/images/placeholderimage.png",
};

export default ImageConstant;
